import styled from "styled-components";

export const DesignContainer = styled.div`
  position: relative;
  border-radius: ${({ borderRadius = 14 }) => `${borderRadius}px`};
  height: fit-content;

  ${({ hasHover, theme }) =>
    hasHover &&
    `
    &:hover {
      outline-offset: 3px;
      outline: 6px solid ${theme.border.brand}4d;
    }`}

  .remove-from-library {
    visibility: hidden;
  }

  &:hover {
    .remove-from-library {
      visibility: visible;
    }
  }

  ${({ isSelected, theme }) =>
    isSelected &&
    `
      outline-offset: 3px;
      outline: 6px solid ${theme.border.brand}4d;
    `}
`;
